import View from './FormLogin';
import enhancer from './FormLogin.enhancer';

const FormLogin = enhancer(View);

export default FormLogin;
